import React, { useEffect, useState } from 'react'
import NotificationService from "../../services/Notification";
import { SingleCareRow } from '../../components/List/SingleCareRow';
import { SingleNotifcationLogRow } from '../../components/List/SingleNotifcationLogRow';

export const AppNotifictaionLogList = () => {
    const [list, setList] = useState<any>([]);
    const fetchData = async () => {
        NotificationService.getNotificationLogs()
          .then((res: any) => {
            setList(res.data);
          })
          .catch((error: any) => {
            console.log(error);
          });
      };
      useEffect(() => {
        fetchData();
      }, []);
      return (
        <>
          <div className="main-wrapper">
            <div className="page_title py-2">
              Notifications - App Notification Logs
            </div>

            <div className="p-4">
              {/* Main secttion */}
              <div className="main-section">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Notification Id</th>
                      <th>Application</th>
                      <th>Lead Target</th>
                      {/* <th>Lead Ids</th> */}
                      <th>Status</th>
                      <th>Source</th>
                      <th>Scheduled Date</th>
                      <th>Scheduled Time</th>
                      <th>Trigger Date</th>
                      <th>Trigger Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {list && list.length > 0 ? (
                      list.map((el: any) => (
                        <SingleNotifcationLogRow key={el._id} props={el} />
                      ))
                    ) : (
                      <h1 className="no-data">No Data Found</h1>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </>
      );
}
